<template>
    <div>
        <div v-if="(column.property_name == 'company_type' && column.is_custom_field == false)">
            <select v-model="companyData.selectedCompanyType"
                    @change="inlineUpdate(column.property_name, companyData.selectedCompanyType)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full">
                    <option v-for="item in companyTypes" :value="item.id">{{ item.code }}</option>
            </select>
        </div>
        <div v-if="(column.property_name == 'company_status' && column.is_custom_field == false)">
            <select v-model="companyData.selectedCompanyStatus"
                    @change="inlineUpdate(column.property_name, companyData.selectedCompanyStatus)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full">
                    <option v-for="item in teamCompanyStatuses" :value="item.id">{{ item.name }}</option>
            </select>
        </div>
        <div v-if="(column.is_custom_field && column.custom_field_type == 'TEXT')">
            <input type="text" @change="inlineUpdate(column.custom_field_id, companyData.customFields, true)" v-model="companyData.customFields.value"
            class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none">
        </div>
        <div v-if="(column.is_custom_field && (column.custom_field_type == 'DROPDOWN' || column.custom_field_type == 'USER'))">
            <select v-model="companyData.customFields.value"
                    @change="inlineUpdate(column.custom_field_id, companyData.customFields, true)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full">
                    <option selected></option>
                    <option v-for="item in column.custom_field_options" :value="item.id">{{ item.name }}</option>
            </select>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    export default {
        name: 'inline-update',
        components: {Multiselect},
        props: ['column', 'company', 'companyTypes', 'teamCompanyStatuses'],
        data() {
            return {
                companyData: {
                    selectedCompanyType: (this.company && this.company.company_type && this.company.company_type.id) ? this.company.company_type.id : null,
                    selectedCompanyStatus: (this.company && this.company.company_status && this.company.company_status.id) ? this.company.company_status.id : null,
                    customFields: {
                        id: null,
                        type: null,
                        name: null,
                        value: null
                    }
                }
            }
        },
        mounted() {
            let self = this;
            if(self.column.is_custom_field && self.company && self.company.custom_field_data && self.company.custom_field_data.length > 0) {
                _.forEach(self.company.custom_field_data, function(data) {
                    if(data.id == self.column.custom_field_id) {
                        self.companyData.customFields = {
                            ...data
                        }
                    }
                });
            }
        },
        methods: {
            inlineUpdate(field, value, isCustomField = false) {
                let self = this;
                self.$emit('inlineUpdateLoadingEmit', true);
                let payload = {
                    company: self.company,
                    field: field,
                    value: value,
                    isCustomField: isCustomField
                };
                axios.post(route('api.company.inline.update'), payload).then((data) => {
                    self.$emit('inlineUpdateLoadingEmit', false);
                    self.getToast(2500).fire({
                        type: data.data.type,
                        title: data.data.msg
                    });
                }).
                catch((error) => {
                    self.$emit('inlineUpdateLoadingEmit', false);
                });
            }
        }
    }
</script>
